import { menuActions } from '../actions'
const { FETCH_MENU, FETCHING_MENU, FETCH_MENU_ERROR } = menuActions

const initialState = {
  is_fetching: true,
  fetch_error: false,
  items: []
}

const menu = (state = initialState, action = '') => {
  switch (action.type) {
    case FETCH_MENU:
      return { ...state, items: action.items, is_fetching: false, fetch_error: false }
    case FETCH_MENU_ERROR:
      return { ...state, fetch_error: true, is_fetching: false }
    case FETCHING_MENU:
      return { ...state, is_fetching: action.value, fetch_error: false }
    default:
      return state
  }
}


export default menu



// WEBPACK FOOTER //
// ./src/reducers/menu.js